import React from "react";
// import changguigou from "./changguigou.jpg";
import chengxingou from "./chengxingou.jpg";
class RegularDetail extends React.Component {
  render() {
    return (
      <div style={{ minHeight: "100vh", background: "#f3f4f5" }}>
        <img src={chengxingou} style={{ width: "100%" }} />
      </div>
    );
  }
}

export default RegularDetail;



// WEBPACK FOOTER //
// ./src/staticPage/regular/index.js